<template lang="pug">
v-container(fluid pa-0 ma-0)
  template(v-if="item._index.includes('contacts')")
    v-row(dense align="center")
      v-col(cols="1" class="text-center")
        v-icon(xl) mdi-account-circle
      v-col
        span(class="tw-capitalize") {{ item._source.name }} {{ item._source.last_name }}
  template(v-if="item._index.includes('properties')")
    v-row(dense align="center")
      v-col(cols="1")
        template(v-if="item._source.main_image.path")
          v-img(aspect-ratio="1.7" width="100" height="50" :src="path(item._source.main_image.path)")
        template(v-else)
          v-icon mdi-home
      v-col
        span {{ item._source.name }}
</template>
<script>
export default {
  props: ['item'],
};
</script>
